import React from 'react';
import { FormControl, FormControlLabel, Radio, RadioGroup, Stack, Typography } from '@mui/material';
import { Form } from 'mobx-react-form';
import { observer } from 'mobx-react-lite';

import { wrapForm, FormOptions } from 'components/shared/form';
import { plugins } from 'forms/utils/formPlugins';
import { formOptions } from 'forms/utils/formOptions';
import { ExpenseForecastPage } from './ExpenseForecastPage';
import { expenseForecastFormFields } from './expenseForecastFormConfig';
import { EXPENSE_ENTRY_MODE_RADIO_BUTTON_ITEMS } from '../constants';
import { SummarizedForecastPage } from './SummarizedForecastPage';

const formConfig: FormOptions = {
  fields: expenseForecastFormFields,
  options: {
    ...formOptions,
    validateOnChange: true,
  },
  plugins,
};

type ExpenseForecastProps = {
  form: Form;
};

const ExpenseForecastContainer = observer(({ form }: ExpenseForecastProps) => {
  const expenseForecastEntryModeField = form.$('incomeApproach.expenses.expenseForecastEntryMode');

  return (
    <Stack spacing={2}>
      <Typography variant="h6">Expense Forecasts</Typography>

      <FormControl>
        <RadioGroup
          {...form.$('incomeApproach.expenses.expenseForecastEntryMode').bind()}
          row
          sx={{ minHeight: 40, mt: 0 }}
        >
          {EXPENSE_ENTRY_MODE_RADIO_BUTTON_ITEMS.map(({ value, label }) => (
            <FormControlLabel control={<Radio />} key={value} sx={{ mb: 3 / 4 }} {...{ label, value }} />
          ))}
        </RadioGroup>
      </FormControl>

      {expenseForecastEntryModeField.value !== 'summarized' ? (
        <ExpenseForecastPage form={form} />
      ) : (
        <SummarizedForecastPage form={form} />
      )}
    </Stack>
  );
});

export default wrapForm(formConfig)(ExpenseForecastContainer);
